interface KpiItem {
    label: string;
    value: string | number;
    unit?: string;
}

interface ReportKpiProps {
    items: KpiItem[];
    loading?: boolean;
    cols?: number;
}

const COL_CLASSES: Record<number, string> = {
    2: 'grid-cols-2',
    3: 'grid-cols-2 md:grid-cols-3',
    4: 'grid-cols-2 md:grid-cols-4',
};

export function ReportKpi({ items, loading, cols = 4 }: ReportKpiProps) {
    const gridClass = COL_CLASSES[cols] ?? COL_CLASSES[4];

    if (loading) {
        return (
            <div className={`grid ${gridClass} gap-4`}>
                {Array.from({ length: cols }, (_, i) => (
                    <div key={i} className="bg-gray-50 rounded-lg p-4 animate-pulse">
                        <div className="h-4 bg-gray-200 rounded w-2/3 mb-2" />
                        <div className="h-8 bg-gray-200 rounded w-1/2" />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={`grid ${gridClass} gap-4`}>
            {items.map((item) => (
                <div key={item.label} className="bg-gray-50 rounded-lg p-4 text-center">
                    <p className="text-xs text-gray-500 uppercase tracking-wide">{item.label}</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">
                        {item.value}
                        {item.unit && <span className="text-sm font-normal text-gray-500 ml-1">{item.unit}</span>}
                    </p>
                </div>
            ))}
        </div>
    );
}
